// Module
var code = `<!-- ko ifnot: data.iconName-->
<!-- ko if: data.disabled-->
<span class="svc-action-button svc-action-button--disabled" data-bind="text:data.text, class: data.classes, attr: { title: data.title}"></span>
<!-- /ko -->
<!-- ko ifnot: data.disabled -->
<span role="button" class="svc-action-button" data-bind="text:data.text, click: onClick, key2click, attr: { title: data.title, 'aria-label': data.text }, class: data.classes, css:{'svc-action-button--selected':data.selected}"></span>
<!-- /ko -->
<!-- /ko -->

<!-- ko if: data.iconName-->
<!-- ko if: data.disabled -->
<sv-svg-icon class="svc-action-button svc-action-button--disabled svc-action-button--icon" data-bind="class: data.classes, attr: { title: data.title}" params="iconName: data.iconName, size: 'auto'">
</sv-svg-icon>
<!-- /ko -->
<!-- ko ifnot: data.disabled -->
<sv-svg-icon class="svc-action-button svc-action-button--icon" data-bind="click: onClick, key2click, attr: { title: data.title, 'aria-label': data.text }, class: data.classes, css:{'svc-action-button--selected':data.selected}" params="iconName: data.iconName, size: 'auto'">
</sv-svg-icon>
<!-- /ko -->
<!-- /ko -->`;
// Exports
export default code;